import styled from 'styled-components'
import Text from 'common-components/Text'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { disableImageDraggableStyleMixin } from 'styles/mixins'

export const GenreThumbnailWrapper = styled.div`
  width: 100%;
  height: 48px;
  position: relative;
  border-radius: 4px;
  margin-bottom: 16px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin-bottom: 8px;
  }
`
export const GenreThumbnail = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  ${disableImageDraggableStyleMixin()}
`

export const GenreThumbnailLabel = styled(Text)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
